<template>
    <div>
        <div class="pa-3">
            <v-card class="pt-2 px-3">
                <v-layout class="mx-3 mt-0" row>
                    <div
                        style=""
                        class="pt-3 text-xs-center font-weight-medium title"
                    >
                        Recent Accounts ({{ all.length }})
                    </div>
                </v-layout>

                <v-checkbox
                    @change="loadRecentPages"
                    v-model="onlyCurrentUser"
                    color="success"
                    :label="'Only for ' + user"
                    class="ml-3 mb-3 mt-2"
                    hide-details
                ></v-checkbox>
                <div style="height: 800px; overflow-y: auto;" class="mx-3 mb-3">
                    <v-layout
                        row
                        class="pa-3 mb-2"
                        justify-space-between
                        v-for="(page, index) in recentPagesToDisplay"
                        @click="pageClicked(page)"
                        style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                    >
                        <div class=" pl-3 font-weight-regular width-300">
                            {{ page.date | time }}
                        </div>
                        <div class=" font-weight-regular width-200">
                            {{ page.accountID }}
                        </div>
                        <div class=" font-weight-regular width-250">
                            {{ page.name }}
                        </div>

                        <div class=" width-250">
                            {{ page.user }}
                        </div>
                        <div class=" width-350 mr-4">
                            <a :href="page.page" class="website-link-text">{{
                                decodeURI(page.page.substring(1))
                            }}</a>
                        </div>
                    </v-layout>
                    <v-layout justify-center>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="7"
                            v-on:input="setPagianation"
                        ></v-pagination>
                    </v-layout>
                </div>
            </v-card>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data() {
        return {
            recentPagesToDisplay: [],
            loading: false,
            onlyCurrentUser: true,
            user: "",

            deleting: false,
            uploading: false,

            pagination: {
                totalCount: 0,
                rowsPerPage: 11,
                page: 1,
            },

            all: [],
        };
    },
    async created() {
        this.user = this.$store.state.authentication.user;

        this.loadRecentPages();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.all.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    methods: {
        async loadRecentPages() {
            this.loading = true;

            const recentPages = await this.$http.get(
                "api/RecentPage/GetRecentPages?type=YKC" +
                    (this.onlyCurrentUser ? "&user=" + this.user : "")
            );

            this.all = recentPages;

            this.recentPagesToDisplay = this.all.slice(0, 11);

            this.loading = false;
            this.pagination.page = 1;
        },
        pageClicked(page) {
            this.$router.push({
                name: "YKCAccountView",
                params: { id: page.accountID },
            });
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.recentPagesToDisplay = this.all.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
    },
};
</script>
<style>
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
</style>
